export const usageData = {
  "txe": {
    "used": 10568,
    "total": 26218,
    "unit": "TXE",
    "currency": "CHF",
    "lastSync": "2025-12-23T10:00:00Z"
  }
};